import AcumuladoresForm from "./AcumuladoresForm";
export default AcumuladoresForm;
